/** DTOs' keys from `project` module */
export enum ProjectDtoKeysEnum {
  /** Deadline delay response body */
  DEADLINE_DELAY_REQUEST_FIND_DTO = 'project/deadline-delay-request-find.dto',
  /** Deadline delay create API request body */
  DEADLINE_DELAY_REQUEST_FORM_DTO = 'project/deadline-delay-request-form.dto',
  /** Project templates list API query parameters */
  PROJECT_TEMPLATE_LIST_QUERY_DTO = 'project/project-template-list-query.dto',
  /** Project template registry selectable item */
  PROJECT_TEMPLATE_REGISTRY_SELECTABLE_ITEM_DTO = 'project/project-template-registry-selectable-item.dto',
  /** Project template registry column selection */
  PROJECT_TEMPLATE_SELECT_DTO = 'project/project-template-select.dto',
  /** Project template registry sorting */
  PROJECT_TEMPLATE_SORT_DTO = 'project/project-template-sort.dto',
  /** Project template registry filters */
  PROJECT_TEMPLATE_REGISTRY_FILTERS_DTO = 'project/project-template-registry-filters.dto',
  /** Project template registry query */
  PROJECT_TEMPLATE_REGISTRY_QUERY_DTO = 'project/project-template-registry-query.dto',
  /** Project template registry export query */
  PROJECT_TEMPLATE_EXPORT_QUERY_DTO = 'project/project-template-export-query.dto',
  /** Project template registry page */
  PROJECT_TEMPLATE_ITEMS_PAGE_DTO = 'project/project-template-items-page.dto',
  /** Accessible projects API query parameters */
  PROJECT_ACCESSIBLE_QUERY_DTO = 'project/project-accessible-query.dto',
  /** Project file response body */
  PROJECT_FILE_FIND_DTO = 'project/project-file-find.dto',
  /** Project history list API query parameters */
  /** Project files attachement API request body */
  PROJECT_ADD_FILES_DTO = 'project/project-add-files.dto',
  /** Project create API request body */
  PROJECT_CREATE_DTO = 'project/project-create.dto',
  /** Project deal assignment API request body */
  PROJECT_DEAL_ASSIGN_DTO = 'project/project-deal-assign.dto',
  /** Project's deal APIs URL paramaters */
  PROJECT_DEAL_PARAMS_DTO = 'project/project-deal-params.dto',
  /** Project's deals list API query parameters */
  PROJECT_DEAL_QUERY_DTO = 'project/project-deal-query.dto',
  /** Projects response body */
  PROJECT_FIND_DTO = 'project/project-find.dto',
  /** Project update API request body */
  PROJECT_FORM_DTO = 'project/project-form.dto',
  /** Project HD tasks widget API query parameters */
  PROJECT_HELPDESK_TASKS_QUERY_DTO = 'project/project-helpdesk-tasks-query.dto',
  /** Project HD tasks widget paginated list API query parameters */
  PROJECT_HELPDESK_TASKS_PAGE_QUERY_DTO = 'project/project-helpdesk-tasks-page-query.dto',
  /** Project HD tasks assign API request body */
  PROJECT_HELPDESK_TASKS_FORM_DTO = 'project/project-helpdesk-tasks-form.dto',
  /** Projects page response body */
  PROJECT_PAGE_FIND_DTO = 'project/project-page-find.dto',
  /** Project list APIs base filters */
  PROJECT_LIST_FILTERS_DTO = 'project/project-list-filters.dto',
  /** Project list APIs common query parameters */
  PROJECT_LIST_QUERY_DTO = 'project/project-list-query.dto',
  /** Project list registry selectable item */
  PROJECT_LIST_REGISTRY_SELECTABLE_ITEM_DTO = 'project/project-list-registry-selectable-item.dto',
  /** Project list registry column selection */
  PROJECT_LIST_SELECT_DTO = 'project/project-list-select.dto',
  /** Project list registry sorting */
  PROJECT_LIST_SORT_DTO = 'project/project-list-sort.dto',
  /** Project list registry filters */
  PROJECT_LIST_REGISTRY_FILTERS_DTO = 'project/project-list-registry-filters.dto',
  /** Project list registry query */
  PROJECT_LIST_REGISTRY_QUERY_DTO = 'project/project-list-registry-query.dto',
  /** Project list registry export query */
  PROJECT_LIST_EXPORT_QUERY_DTO = 'project/project-export-query.dto',
  /** Project list registry page */
  PROJECT_LIST_ITEMS_PAGE_DTO = 'project/project-list-items-page.dto',
  /** Project partial update API request body */
  PROJECT_PARTIAL_UPDATE_DTO = 'project/project-partial-update.dto',
  /** Project simplified list API request body */
  PROJECT_SIMPLIFIED_LIST_QUERY_DTO = 'project/project-simplified-list-query.dto',
  /** Project workflow actions' APIs response body */
  PROJECT_WORKFLOW_ACTION_RESULT_DTO = 'project/project-workflow-action-result.dto',
  /** Project workflow APIs permissions for current authorized user */
  PROJECT_WORKFLOW_PERMISSIONS_DTO = 'project/project-workflow-permissions.dto',
  /** Projects template response body */
  PROJECT_TEMPLATE_FIND_DTO = 'project/project-template-find.dto',
  /** Project template create and update APIs request body */
  PROJECT_TEMPLATE_FORM_DTO = 'project/project-template-form.dto',
  /** Project time report target entity (project, HD task etc.) response body */
  PROJECT_TIME_REPORT_ENTITY_DTO = 'project/project-time-report-entity.dto',
  /** Project time report registry selectable item */
  PROJECT_TIME_REPORT_REGISTRY_SELECTABLE_ITEM_DTO = 'project/project-time-report-registry-selectable-item.dto',
  /** Project time report registry column selection */
  PROJECT_TIME_REPORT_SELECT_DTO = 'project/project-time-report-select.dto',
  /** Project time report registry sorting */
  PROJECT_TIME_REPORT_SORT_DTO = 'project/project-time-report-sort.dto',
  /** Project time report subtotal sorting */
  PROJECT_TIME_REPORT_SUBTOTAL_SORT_DTO = 'project/project-time-report-subtotal-sort.dto',
  /** Project time report common filters */
  PROJECT_TIME_REPORT_FILTERS_DTO = 'project/project-time-report-filters.dto',
  /** Project time report items page query */
  PROJECT_TIME_REPORT_ITEMS_QUERY_DTO = 'project/project-time-report-items-query.dto',
  /** Project time report registry export query */
  PROJECT_TIME_REPORT_EXPORT_QUERY_DTO = 'project/project-time-report-export-query.dto',
  /** Project time report subtotal query */
  PROJECT_TIME_REPORT_SUBTOTAL_QUERY_DTO = 'project/project-time-report-subtotal-query.dto',
  /** Project time report plot query */
  PROJECT_TIME_REPORT_PLOT_QUERY_DTO = 'project/project-time-report-plot-query.dto',
  /** Project time report items page response body */
  PROJECT_TIME_REPORT_ITEMS_PAGE_DTO = 'project/project-time-report-items-page.dto',
  /** Project time report subtotal response body */
  PROJECT_TIME_REPORT_SUBTOTAL_DTO = 'project/project-time-report-subtotal.dto',
  /** Project time report subtotal settings */
  PROJECT_TIME_REPORT_SUBTOTAL_SETTINGS_DTO = 'project/project-time-report-subtotal-settings.dto',
  /** Project time report plot settings */
  PROJECT_TIME_REPORT_PLOT_SETTINGS_DTO = 'project/project-time-report-plot-settings.dto',
  /** Project time report item status response body */
  PROJECT_TIME_REPORT_ITEM_STATUS_DTO = 'project/project-time-report-item-status.dto',
  /** Project time report item response body */
  PROJECT_TIME_REPORT_ITEMS_DTO = 'project/project-time-report-items.dto',
  /** Project time report summary row response body */
  PROJECT_TIME_REPORT_SUMS_DTO = 'project/project-time-report-sums.dto',
  /** Checklist response body */
  CHECKLIST_FIND_DTO = 'project/checklist-find.dto',
  /** Checklist finish API request body */
  CHECKLIST_FINISH_DTO = 'project/checklist-finish.dto',
  /** Checklist API query parameters */
  CHECKLIST_QUERY_DTO = 'project/checklist-query.dto',
  /** Checklist create and update APIs request body */
  CHECKLIST_FORM_DTO = 'project/checklist-form.dto',
  /** Checklist create and update APIs extended request body with project */
  CHECKLIST_FORM_WITH_PROJECT_DTO = 'project/checklist-form-with-project.dto',
  /** Checklist reopen API request body */
  CHECKLIST_REOPEN_DTO = 'project/checklist-reopen.dto',
  /** Checklist reschedule API request body */
  CHECKLIST_RESCHEDULE_DTO = 'project/checklist-reschedule.dto',
  /** Checklist template response body */
  CHECKLIST_TEMPLATE_FIND_DTO = 'project/checklist-template-find.dto',
  /** Checklist template create and update APIs request body */
  CHECKLIST_TEMPLATE_FORM_DTO = 'project/checklist-template-form.dto',
  /** Checklist type response body */
  CHECKLIST_TYPE_FIND_DTO = 'project/checklist-type-find.dto',
  /** Checklist type create and update APIs request body */
  CHECKLIST_TYPE_FORM_DTO = 'project/checklist-type-form.dto',
  /** Sub-project default values response body */
  SUBPROJECT_DEFAULTS_FIND_DTO = 'project/subproject-defaults-find.dto',
  /** Sub-project default values created and update requests body */
  SUBPROJECT_DEFAULTS_FORM_DTO = 'project/subproject-defaults-form.dto',
  /** Project status list APIs base filters */
  STATUS_FILTERS_DTO = 'project/status-filters.dto',
  /** Project status response body */
  STATUS_FIND_DTO = 'project/status-find.dto',
  /** Project status create and update APIs request body */
  STATUS_FORM_DTO = 'project/status-form.dto',
  /** Project status list API response body */
  STATUS_PAGE_DTO = 'project/status-page.dto',
  /** Project status list APIs query parameters */
  STATUS_QUERY_DTO = 'project/status-query.dto',
}
